// Padel-ball brand mark (splash, auth headers, empty states) — the ONE brand
// glyph app-wide (founder call 2026-07-05: ball everywhere, racket retired).
// Same geometry as the boot-splash inline SVG in index.html and the generated
// favicon / PWA icons (scripts/generate-brand-icons.py) — change one, sync all.
// Inherits `currentColor` so callers tint it via text color (accent/mint/sky).
export function BrandMark({ size = 64, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-label="uPadelMatch"
      className={className}
    >
      <circle cx="32" cy="32" r="24" stroke="currentColor" strokeWidth="3.5" />
      {/* seams — two opposing curves, tennis-ball style */}
      <path
        d="M15 15 C 28 24, 28 40, 15 49"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M49 15 C 36 24, 36 40, 49 49"
        stroke="currentColor"
        strokeWidth="3.5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  )
}
